import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { Section } from './index';
import { APPLIANCES } from '../constants';

export default class AppliancesSection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: APPLIANCES.FIELD_NAME.IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: APPLIANCES.FIELD_NAME.NAME,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
    ]);
  }
}
